import classNames from "classnames";
import React from "react";
import CardContent from "../../components/CardContent/CardContent";
import FavouriteButton from "../../components/FavouriteButton/FavouriteButton";
import { BreakpointValues, ImageRatios } from "../../components/Image/Image";
import ImageCard from "../../components/ImageCard/ImageCard";
import Text from "../Text/Text";
import { urlForDocument } from "../../urls";
import { SanityMake } from "../../model/makes";
import LevelIndicator from "../LevelIndicator/LevelIndicator";
import styles from "./MakeCard.module.scss";
import { ProgrammingLanguage } from "../../model/common";

const MakeCard = ({
  className,
  preferredEditor,
  make,
  widths = [232, 400, 400]
}: MakeCardProps) => {
  const url =
    urlForDocument(make) +
    (preferredEditor ? `?editor=${encodeURIComponent(preferredEditor)}` : "");

  const { title, description, image, level, _id } = make;
  return (
    <ImageCard
      className={classNames(styles.root, className)}
      widths={widths}
      aspectRatio={ImageRatios.Landscape_4_3}
      image={image}
      href={url}
    >
      <CardContent title={title} text={description} href={url}>
        <div className={styles.flexRow}>
          <Text variant="defaultTiny">
            <LevelIndicator value={level} />
          </Text>
          <FavouriteButton id={_id} />
        </div>
      </CardContent>
    </ImageCard>
  );
};

interface MakeCardProps {
  className?: string;
  make: SanityMake;
  preferredEditor?: ProgrammingLanguage;
  widths?: BreakpointValues;
}

export default MakeCard;
